/**
 * 初始化播放器配置
 * 从 URL 参数中获取播放器内核信息，并存储到 store
 */

import { usePlayerStore } from '@/stores/playerStore';
import { getInitPlayerKernel } from './getPlayerKernel';
import { logger } from './devUtils';

/**
 * 初始化播放器配置
 * 在应用启动时调用，从 URL 参数获取配置并存储到 store
 */
export function initPlayerConfig(): void {
  // 获取播放器内核（从 localStorage 或使用默认值）
  const playerKernel = getInitPlayerKernel();

  // 存储到 store
  usePlayerStore.getState().setPlayerKernel(playerKernel);

  // 开发环境下打印配置信息
  if (process.env.NODE_ENV === 'development') {
    logger.log('[player] 播放器配置初始化:', {
      playerKernel,
    });
  }
}
